import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-details-tab',
  templateUrl: './details-tab.component.html',
  styleUrls: ['./details-tab.component.scss'],
})
export class DetailsTabComponent {
  @Input() loading = false;
  @Input() toolbarItems: any[] = [];
  @Input() model: any = null;
  @Input() errorMessage: string = null;

  constructor() {}
}
